@import url(~resources-module/stylesheet-import2.css) print, screen;
@import url(stylesheet-import3.css) print and screen;

.rule-import1 {
	background: lightgreen;
}



/** WEBPACK FOOTER **
 ** ./loaders/_css/folder/stylesheet-import1.css
 **/